<template lang="">
  <div>
    <section>
      <div class="w-full mx-auto max-w-7xl 2xl:max-w-screen-2xl">
        <!-- Desktop -->
        <div class="hidden md:block mt-[2rem] mb-[2rem] md:px-5">
          <div class="flex justify-center items-center">
            <div class="w-1/2 p-4">
              <h2
                class="text-black font-extrabold text-left md:text-xl lg:text-3xl"
              >
                Make Your Dreams a
                <br />
                Reality with Us
              </h2>
              <p
                class="font-bold text-lg lg:text-2xl text-left text-black pt-4"
              >
                Degrees from JAIN Online are:
              </p>
              <ul class="text-left ml-4 pt-5 text-black text-[18px]">
                <li class="list-disc text-base lg:text-xl">
                  Equivalent to JAIN (Deemed-to-be University) on-campus degree
                </li>
                <li class="list-disc text-base lg:text-xl mt-4">
                  Globally recognized
                </li>
              </ul>
              <div class="flex gap-3">
                <div>
                  <a :href="dynamicHref" target="blank">
                    <button
                      class="bg-[#F8C300] float-left mt-5 text-[#001C54] font-semibold rounded-3xl px-5 py-3"
                      @click="handleApplyNowClick"
                    >
                      Apply Now
                    </button>
                  </a>
                </div>
              </div>
            </div>
            <div class="relative p-2">
              <div
                class="bg-[#001C54] w-[400px] lg:w-[500px] 2xl:w-[550px] h-[300px] 2xl:h-[350px] rounded-3xl"
              >
                <img
                  src="@/assets/home/JAIN-Online-degree-certificate.webp"
                  alt=""
                  class="absolute top-0 left-7 w-[350px] lg:w-[450px] 2xl:w-[500px] h-full p-10 rounded-[50px]"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- Desktop -->

        <!-- Mobile -->
        <div class="md:hidden mt-[2rem] mb-[2rem]">
          <div class="w-full mx-auto">
            <h2 class="text-left ml-4 text-black font-extrabold text-2xl">
              Make Your Dreams a Reality
              <br />
              with Us
            </h2>
            <div class="">
              <div class="bg-[#001C54] h-[300px] m-3 rounded-3xl">
                <img
                  src="@/assets/home/JAIN-Online-degree-certificate.webp"
                  alt="sample-certificate"
                  class="w-full h-full p-10 rounded-[50px]"
                />
              </div>
            </div>
            <div>
              <p
                class="text-left ml-4 text-black font-semibold text-[16px] mt-2"
              >
                Degrees from JAIN Online are:
              </p>
              <ul class="text-black pt-3 text-left ml-8">
                <li class="list-disc mt-3">
                  Equivalent to JAIN (Deemed-to-be University) on-campus degree
                </li>
                <li class="list-disc mt-3">Globally recognized</li>
              </ul>
            </div>
            <div class="flex justify-center gap-6 px-4 mt-5">
              <a
                :href="dynamicHref"
                class="bg-[#F8C300] text-[#001C54] text-[16px] font-semibold w-full py-3 rounded-3xl"
                @click="handleApplyNowClick"
              >
                <div>Apply Now</div>
              </a>
            </div>
          </div>
        </div>
        <!-- Mobile -->
      </div>
    </section>
  </div>
</template>
<script>
export default {
  name: "DreamsView",
  props:["widget_id"],
  computed: {
    dynamicHref() {
      const currentPath = this.$route.path;
      // if (currentPath === "/online-mba/data-science") {
      //   return "https://onlinejain.com/gl/mba-data-science-digital-marketing-jain-registration.html?utm_source=university_website&utm_medium=second_scroll&utm_campaign=applynow_onlinejain";
      // } else if (
      //   currentPath === "/online-mba/digital-marketing-and-ecommerce"
      // ) {
      //   return "https://onlinejain.com/gl/mba-data-science-digital-marketing-jain-registration.html?utm_source=university_website&utm_medium=second_scroll&utm_campaign=applynow_onlinejain";
      // } else if (currentPath === "/online-bba/digital-marketing") {
      //   return "https://onlinejain.com/gl/bba-degree-jain-online-registration.html?utm_source=university_website&utm_medium=second_scroll&utm_campaign=applynow_onlinejain";
      // } else if (currentPath === "/online-bba/data-science-and-analytics") {
      //   return "https://onlinejain.com/gl/bba-degree-jain-online-registration.html?utm_source=university_website&utm_medium=second_scroll&utm_campaign=applynow_onlinejain";
      // } else if (currentPath === "/online-mca/full-stack-development") {
      //   return "https://onlinejain.com/gl/jain-online-master-of-computer-applications-registration.html?utm_source=university_website&utm_medium=second_scroll&utm_campaign=applynow_onlinejain";
      // } else if (currentPath === "/online-mca/cloud-computing") {
      //   return "https://onlinejain.com/gl/jain-online-master-of-computer-applications-registration.html?utm_source=university_website&utm_medium=second_scroll&utm_campaign=applynow_onlinejain";
      // } else if (currentPath === "/online-mca/data-science") {
      //   return "https://onlinejain.com/gl/jain-online-master-of-computer-applications-registration.html?utm_source=university_website&utm_medium=second_scroll&utm_campaign=applynow_onlinejain";
      // } else if (currentPath === "/online-mca/artificial-intelligence") {
      //   return "https://onlinejain.com/gl/jain-online-master-of-computer-applications-registration.html?utm_source=university_website&utm_medium=second_scroll&utm_campaign=applynow_onlinejain";
      // } else {
      //   return "https://application.onlinejain.com/";
      // }
      if (this.widget_id!=null && this.widget_id!='') {
        return `https://application.onlinejain.com/?id=${this.widget_id}`;
      } else {
        return "https://application.onlinejain.com/";
     
      }
    },
  },
  methods: {
    handleApplyNowClick() {
      dataLayer.push({
        "event": "Apply Online Initiated",
        "Attribute": {
          "CTA": "Apply Now",
          "Section Name": "Make Your Dreams a Reality with Us",
        },
      });
      console.log("window.dataLayer::::", window.dataLayer);
    },
  },
};
</script>
<style></style>
